<template>
  <div class="upload">
    <el-upload
      :action="uploadOptions.url"
      :headers="uploadOptions.header"
      class="avatar-uploader"
      name="file"
      accept="image/png, image/jpeg"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :style="`width: ${width}; height: ${height}`"
    >
      <img
        v-if="imgUrl.absoluteUrl"
        :src="imgUrl.absoluteUrl"
        class="avatar"
        :style="`width: ${width}; height: ${height}`"
      >
      <i v-else class="el-icon-picture-outline avatar-uploader-icon" />
    </el-upload>
  </div>
</template>

<script>
import { getStore } from '@/utils/store'

class UploadOptions {
  url = process.env.VUE_APP_BASE_API + 'admin/file/save';
  header = {
    'Auth-Key': getStore('authKey') ? getStore('authKey') : '',
    'Session-Id': getStore('sessionId') ? getStore('sessionId') : '',
    'Platform': 'pc'
  }
}

export default {
  name: 'ImgUploadOne',
  props: {
    // 方案二：existUrl 接收字符串类型的图片URL
    existUrl: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '146px'
    },
    height: {
      type: String,
      default: '146px'
    },
  },
  data() {
    return {
      uploadOptions: new UploadOptions(),
      imgUrl: {
        absoluteUrl: '',
        relativeUrl: ''
      }
    };
  },
  watch: {
    // 监听父组件传入的图片URL字符串
    existUrl: {
      handler(newVal) {
        if (newVal) {
          // 如果传入的是完整URL，直接赋值给absoluteUrl
          this.imgUrl.absoluteUrl = newVal;
        } else {
          // 如果传入空字符串，清空图片
          this.imgUrl.absoluteUrl = '';
          this.imgUrl.relativeUrl = '';
        }
      },
      immediate: true // 组件初始化时立即执行
    }
  },
  mounted() {
    // 兜底：如果watch没有触发，这里做初始化
    if (this.existUrl) {
      this.imgUrl.absoluteUrl = this.existUrl;
    }
  },
  methods: {
    // 清空图片（新增弹窗调用）
    open() {
      this.imgUrl = {
        absoluteUrl: '',
        relativeUrl: ''
      };
      // 通知父组件清空
      this.$emit('setUrl', {
        absoluteUrl: '',
        relativeUrl: ''
      });
    },
    // 上传前校验
    beforeAvatarUpload(file) {
      const isImage = file.type.indexOf('image') !== -1;
      if (!isImage) {
        this.$message.error('请上传正确的图片格式');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传凭证图片大小不能超过10MB!');
        return false;
      }
      return true;
    },
    // 上传成功回调，抛出图片对象给父组件
    handleAvatarSuccess(res) {
      if (res.code === 200) {
        const { data } = res;
        this.imgUrl = {
          absoluteUrl: data.file_path,
          relativeUrl: data.save_name
        };
        // 向父组件传递完整的图片对象
        this.$emit('setUrl', this.imgUrl);
      } else {
        this.$message.error(res.msg || '图片上传失败');
      }
    }
  }
};
</script>

<style scoped lang="scss">
  $img_width: 146px;
  $img_height: 146px;
  
  .avatar-uploader ::v-deep.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader ::v-deep.el-upload:hover {
    border-color: #295394;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: $img_width;
    height: $img_height;
    line-height: $img_height;
    text-align: center;
  }
  .avatar {
    width: $img_width;
    height: $img_height;
    display: block;
    object-fit: cover;
  }
  .big {
    width: 300px;
    max-height: 600px;
    display: block;
    margin: 0 auto;
  }
</style>